module.exports = __webpack_public_path__ + "img/success.7af1623f.svg";